






















import { DurationTime } from '@/types/global';
import compareObj from '@/utils/comparison';
import Axios, { AxiosResponse } from 'axios';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import TopoSelect from './topo-select.vue';

@Component({components: {TopoSelect}})
export default class TopoServices extends Vue {
  @Getter('durationTime') public durationTime: any;
  @Action('rocketTopo/GET_TOPO') public GET_TOPO: any;
  private services = [{key: 0, label: 'All services'}];
  private service = {key: 0, label: 'All services'};

  private fetchData() {
    Axios.post('/graphql', {
      query: `
    query queryServices($duration: Duration!) {
      services: getAllServices(duration: $duration) {
        key: id
        label: name
      }
    }`,
      variables: {
        duration: this.durationTime,
      },
    }).then((res: AxiosResponse) => {
      this.services = res.data.data.services
        ?
        [{key: 0, label: 'All services'}, ...res.data.data.services]
        :
        [{key: 0, label: 'All services'}];
    });
  }

  @Watch('durationTime')
  private watchDurationTime(newValue: DurationTime, oldValue: DurationTime) {
    // Avoid repeating fetchData() after enter the component for the first time.
    if (compareObj(newValue, oldValue)) {
      this.fetchData();
    }
  }

  private handleChange(i: any) {
    this.service = i;
    this.GET_TOPO({serviceId: this.service.key, duration: this.durationTime});
  }

  private created() {
    this.fetchData();
  }
}
